// Identify the device as touch device
// Google Recaptcha v3
grecaptcha.ready(function () {
	$('form.mod-recaptcha').each(function () {
		var object = $(this);
		grecaptcha.execute('6LfzXCgaAAAAAHmBbTUGH2mKqCErInu0HwtunLlB', { action: 'homepage' }).then(function (token) {
			console.log('token: ' + token);
			$('<input>').attr({
				type: 'hidden',
				name: 'g-recaptcha-response',
				value: token
			}).appendTo(object)
		});
	});
});

function hasTouch() {
	return 'ontouchstart' in document.documentElement
		|| navigator.maxTouchPoints > 0
		|| navigator.msMaxTouchPoints > 0;
}

// Hack to remove all hover effects on touch devices
if (hasTouch()) { // remove all :hover stylesheets
	try { // prevent exception on browsers not supporting DOM styleSheets properly
		for (var si in document.styleSheets) {
			var styleSheet = document.styleSheets[si];
			if (!styleSheet.rules) continue;

			for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
				if (!styleSheet.rules[ri].selectorText) continue;

				if (styleSheet.rules[ri].selectorText.match('btn:hover')) {
					styleSheet.deleteRule(ri);
				}
			}
		}
	} catch (ex) { }
}

// Mobile Nav
$('.mob-hamburger').click(function (e) {
	e.preventDefault();

	$(this).toggleClass('mod-active');
	$('body').toggleClass('no-scroll');
	$('#nav > ul').toggleClass('mod-active');
	$('.logo').fadeToggle();
});

$(window).on('scroll load', function () {
	const header = $(".header-main"),
		hero = $('.section-hero:not(.mod-home) .sub-copy'),
		heroSmall = $('.section-hero.mod-small .sub-copy'),
		heroHome = $('#home .section-hero');

	hero.css({
		"top": Math.max(50 + 0.06 * window.scrollY, 0) + "%",
		"opacity": 1 - $(window).scrollTop() / 500
	});
	heroSmall.css({
		"top": Math.max(50 + 0.1 * window.scrollY, 0) + "%",
		"opacity": 1 - $(window).scrollTop() / 150
	});
	header.css("opacity", 1 - $(window).scrollTop() / 90);
	heroHome.css("opacity", 1 - $(window).scrollTop() / 250);
});

// Ajax login form processing
$('#referral form.mod-login').submit(function (e) {
	e.preventDefault();

	$.ajax({
		method: 'POST',
		url: 'process/login/',
		data: $(this).serialize()
	}).done(function (response) {
		// If no errors
		if (response != 'success') {
			$('#referral form.mod-login .sub-errors').fadeIn().html(response);
			$('#referral form.mod-login .form-element').addClass('mod-error');
		}
	});
});

// Ajax referral form processing
$('#contact form').submit(function (e) {
	e.preventDefault();

	$.ajax({
		method: 'POST',
		url: 'process/contact/',
		data: $(this).serialize()
	}).done(function (response) {

		// if honeypot field is filled in by spambot, do not submit
		if ($('input#Form_Email').val().length != 0) {
			return false;
		}

		// If no errors
		if (response == 'success') {
			// Reset form completely
			$('#contact form .form-element').removeClass('mod-filled');
			$('#contact form').hide().trigger('reset');

			// Show thank you message
			$('#contact .section-thanks').fadeIn();

			// Remove any errors that may still be there
			$('#contact form .sub-errors').html('');

			// Hide thank you message after 10 seconds and return to form
			setTimeout(function () {
				$('#contact form').fadeIn();
				$('#contact .section-thanks').hide();
			}, 10000);

		}
		else {
			$('#contact form .sub-errors').fadeIn().html(response);
		}
	});
});


// Ajax referral form processing
$('#referral form.mod-referral').submit(function (e) {
	e.preventDefault();

	// if honeypot field is filled in by spambot, do not submit
	if ($('input#Form_Email').val().length != 0) {
		return false;
	}

	$.ajax({
		method: 'POST',
		url: 'process/referral/',
		data: $(this).serialize()
	}).done(function (response) {

		// If no errors
		if (response == 'success') {
			// Reset form completely
			$('#referral form .form-element').removeClass('mod-filled');
			$('#referral form.mod-referral').hide().trigger('reset');

			// Show thank you message
			$('#referral .section-thanks').fadeIn();

			// Remove any errors that may still be there
			$('#referral form.mod-referral .sub-errors').html('');

			// Hide thank you message after 10 seconds and return to form
			setTimeout(function () {
				$('#referral form.mod-referral').fadeIn();
				$('#referral .section-thanks').hide();
			}, 10000);

		}
		else {
			$('#referral form.mod-referral .sub-errors').fadeIn().html(response);
			$('#referral form.mod-referral .form-element').addClass('mod-error');
		}

		// Call the reset to g-captcha to force a new code to be generated.
		grecaptcha.reset();
	});
});


const svg = '<svg xmlns = "http://www.w3.org/2000/svg" viewBox = "0 0 16 16">' +
	'<path class="circle-bg" d="M8,14.5A6.5,6.5,0,1,1,14.5,8,6.5,6.5,0,0,1,8,14.5Z"></path>' +
	'<path class="circle-fill" d="M8,14.5A6.5,6.5,0,1,1,14.5,8,6.5,6.5,0,0,1,8,14.5Z"></path>' +
	'</svg >';

// Slickify testimonial area
$('ul.list-testimonials, ul.list-experiences').slick({
	arrows: false,
	autoplay: true,
	autoplaySpeed: 7000,
	dots: true,
	customPaging: function (slider, i) {
		return svg;
	},
});

$('form input, form textarea').focus(function () {
	$(this).parent().addClass('mod-filled');

}).blur(function () {
	if ($(this).val()) {
		$(this).parent().addClass('mod-filled');
	} else {
		$(this).parent().removeClass('mod-filled');
	}
});

// Open video modal
if ($('.section-modal').length > 0) {

	// Video Modal
	$('.sub-play-btn').click(function (ev) {
		ev.preventDefault();

		var src = $(this).data('url');

		$('.section-modal.mod-video').addClass('mod-active');
		$('body').addClass('no-scroll');

		// Turn on autoplay for video modals
		var srcAuto = src + "?autoplay=1";
		$('.section-modal.mod-video iframe').attr('src', srcAuto);
	});

	// Gallery Modal
	$('.list-gallery li').click(function (e) {
		// Prevent default action
		e.preventDefault();

		// Grab image url via data attribute
		const image = $(this).data('url');

		// Add open class to modal to reveal
		$('.section-modal.mod-gallery').addClass('mod-active');
		$('body').addClass('no-scroll');
		$(this).addClass('active');

		// Show enlarged image of clicked thumbnail
		$('.section-modal .sub-content').css({
			'background-image': 'url(' + image + ')',
			'background-size': 'cover',
			'background-repeat': 'no-repeat',
			'background-position': 'center'
		});
	});

	// Create next button for lightbox effect
	$('.section-modal .mod-right').click(function (e) {
		e.preventDefault();

		const imageCount = $('.list-gallery').find('li').length,
			currentIndex = $('.list-gallery li.active').index(),
			nextImg = imageCount == (currentIndex + 1)
				? $('.list-gallery li').first()
				: $('.list-gallery li.active').next();

		$('.list-gallery li.active').removeClass('active');

		nextImg.addClass('active');

		$('.section-modal .sub-content').css({
			'background-image': 'url(' + nextImg.data('url') + ')'
		});
	});

	// Create previous button for lightbox effect
	$('.section-modal .mod-left').click(function (e) {
		e.preventDefault();

		const currentIndex = $('.list-gallery li.active').index(),
			prevImg = currentIndex == 0
				? $('.list-gallery li').last()
				: $('.list-gallery li.active').prev();

		$('.list-gallery li.active').removeClass('active');

		prevImg.addClass('active');

		$('.section-modal .sub-content').css({
			'background-image': 'url(' + prevImg.data('url') + ')'
		});
	});

	// Clicking the X button on modal
	$('.section-modal .sub-close').click(function () {

		$('.section-modal').removeClass('mod-active');
		$('body').removeClass('no-scroll');

		// Remove image
		$('.section-modal .sub-content').css('background-image', 'none');

		// Remove active class on gallery item
		$('.list-gallery li.active').removeClass('active');

		// Stop video
		$('iframe').attr('src', $('iframe').attr('src'));

		// Turn off autoplay
		$('.section-modal iframe').attr('src', '');
	});
}

// Pops out share modal window
$(".social-share").click(function (e) {
	// Prevents default action
	e.preventDefault();
	// Runs window popup function
	windowPopup($(this).attr("href"), 500, 300);
});
// Google Maps
if ($('#map').length) {
	function createMap(el, lat, long, zoom, marker) {
		// Set a center point of the map, can be re-evaluated using `centerMap()`
		const center = { lat: lat, lng: long };

		const mapOptions = {
			zoom: zoom,
			center: center,
			fullscreenControl: false,
		};

		// Create a map instance.
		const melonMap = new MelonMap(document.getElementById(el), mapOptions);

		// Marker locations [name, lat, long, zindex]
		const markerLocation = [['Respair', lat, long, 1]];

		if (marker == true) {
			markerLocation.forEach((markerLocation) => {
				const title = markerLocation[0];

				const location = {
					lat: parseFloat(markerLocation[1]),
					lng: parseFloat(markerLocation[2])
				}

				melonMap.addMarker(location, title);
			});
		}

		// Add a map style
		melonMap.setMapStyle(
			[{ "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#d6e2e6" }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#cfd4d5" }] }, { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#7492a8" }] }, { "featureType": "administrative.neighborhood", "elementType": "labels.text.fill", "stylers": [{ "lightness": 25 }] }, { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [{ "color": "#dde2e3" }] }, { "featureType": "landscape.man_made", "elementType": "geometry.stroke", "stylers": [{ "color": "#cfd4d5" }] }, { "featureType": "landscape.natural", "elementType": "geometry.fill", "stylers": [{ "color": "#dde2e3" }] }, { "featureType": "landscape.natural", "elementType": "labels.text.fill", "stylers": [{ "color": "#7492a8" }] }, { "featureType": "landscape.natural.terrain", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi", "elementType": "geometry.fill", "stylers": [{ "color": "#dde2e3" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#588ca4" }] }, { "featureType": "poi", "elementType": "labels.icon", "stylers": [{ "saturation": -100 }] }, { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#a9de83" }] }, { "featureType": "poi.park", "elementType": "geometry.stroke", "stylers": [{ "color": "#bae6a1" }] }, { "featureType": "poi.sports_complex", "elementType": "geometry.fill", "stylers": [{ "color": "#c6e8b3" }] }, { "featureType": "poi.sports_complex", "elementType": "geometry.stroke", "stylers": [{ "color": "#bae6a1" }] }, { "featureType": "road", "elementType": "labels.text.fill", "stylers": [{ "color": "#41626b" }] }, { "featureType": "road", "elementType": "labels.icon", "stylers": [{ "saturation": -45 }, { "lightness": 10 }, { "visibility": "on" }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#c1d1d6" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#a6b5bb" }] }, { "featureType": "road.highway", "elementType": "labels.icon", "stylers": [{ "visibility": "on" }] }, { "featureType": "road.highway.controlled_access", "elementType": "geometry.fill", "stylers": [{ "color": "#9fb6bd" }] }, { "featureType": "road.arterial", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "road.local", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "transit", "elementType": "labels.icon", "stylers": [{ "saturation": -70 }] }, { "featureType": "transit.line", "elementType": "geometry.fill", "stylers": [{ "color": "#b4cbd4" }] }, { "featureType": "transit.line", "elementType": "labels.text.fill", "stylers": [{ "color": "#588ca4" }] }, { "featureType": "transit.station", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit.station", "elementType": "labels.text.fill", "stylers": [{ "color": "#008cb5" }, { "visibility": "on" }] }, { "featureType": "transit.station.airport", "elementType": "geometry.fill", "stylers": [{ "saturation": -100 }, { "lightness": -5 }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#a6cbe3" }] }],
			{ name: 'Styled Map' }
		);
	}

	if ($('#contact').length) {
		createMap('map', 51.801881, -0.6068258, 8, true);
	}
}

// Function for popout window
function windowPopup(url, width, height) {
	// Calculate the position for the popup so it’s centered on the screen.
	const left = (screen.width / 2) - (width / 2);
	const top = (screen.height / 2) - (height / 2);

	// opens a window with the given url & set position from above
	window.open(url, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left);
}

// Ensure the function exists on the page before we call it.
if (!!window['gdprSubscribeModal']) {
	// The form of which to attach the modal to.
	const formSelector = '#contact-form';
	// The url to link to for the privacy policy.
	const privacyPolicyURL = 'privacy-policy.html';
	// Color of the links in the modal
	const linkColour = '#000';
	// Color of the buttons in the modal.
	const buttonTextColour = '#000';

	// Call this per form.
	gdprSubscribeModal(formSelector, privacyPolicyURL, linkColour, buttonTextColour);
}